<template>
  <div class="c-swipe-fullpage" :class="[transition ? 'fullpage-item-transition':'']">
    <div class="fullpage-item"
         :class="[active==index?'active':'']"
         :key="index"
         v-for="(item,index) in viewModel">
      <c-page style="background-color: transparent">
        <c-content>
          <template slot="noscroll">
            <div class="card">
              <img class="img-cover" :src="item.imgCover">
              <div class="content">
                <ul>
                  <li v-for="desc in item.descs" :key="desc">
                    {{ desc.content }}
                  </li>
                </ul>
              </div>
              <div v-if="item.descBtn" class="footer" @click="stdBtn(item.descBtn.func)">
                {{item.descBtn.title}}
              </div>
            </div>
            <c-button v-if="item.btn"
                      :btn-type="item.btn.type"
                      :class="item.btn.class"
                      @click.native="stdBtn(item.btn.func)">
              {{item.btn.title}}
            </c-button>
          </template>
        </c-content>
      </c-page>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import viewModel from '../../model/all-version'
  export default {
    name: 'c-swipe-fullpage',
    data () {
      return {
        viewModel,
        moveObj: {
          start: 0,
          end: 0
        },
        active: 2,
        children: [],
        clientWidth: 0,
        moveToNextPercent: 0.35,
        scalePercent: '.83',
        childrenIndexEnum: {
          now: 'now',
          pre: 'pre',
          next: 'next'
        },
        transition: false
      }
    },
    components: {},
    created () {},
    mounted () {
      let el = this.$el
      this.clientWidth = el.clientWidth
      this.children = el.children
      el.addEventListener('touchstart', event => {
        let touch = event.touches[0]
        this.moveObj.start = touch.pageX
        this.moveObj.end = touch.pageX
      })
      el.addEventListener('touchmove', event => {
        let touch = event.touches[0]
        this.moveObj.end = touch.pageX
        this.touchMove(event)
      })
      el.addEventListener('touchend', event => {
        this.touchEnd(event)
        this.moveObj.start = 0
        this.moveObj.end = 0
      })
      this.moveProcess()
    },
    beforeDestroy () {},
    methods: {
      touchMove (event) {
        let moveDistance = this.moveObj.start - this.moveObj.end
        this.moveProcess(moveDistance * 0.4)
      },
      touchEnd (event) {
        let moveDistance = this.moveObj.start - this.moveObj.end
        let distance = Math.abs(moveDistance)
        let direction = moveDistance > 0 ? -1 : 1 // -1 left, 1 right
        if (distance > this.clientWidth * this.moveToNextPercent) {
          this.transition = true
          this.$nextTick(() => {
            let index = direction > 0 ? this.childrenIndexEnum.next : this.childrenIndexEnum.pre
            this.hideSomeone(this.getChildrenIndex(index))
            this.moveHide(direction)
            this.active = (this.active - direction + this.children.length) % this.children.length
            this.moveProcess()
            setTimeout(() => {
              this.transition = false
            }, 400)
          })
        } else {
          this.moveProcess()
        }
      },
      getShowIndex () {
        let pre = this.getChildrenIndex(this.childrenIndexEnum.pre)
        let now = this.getChildrenIndex(this.childrenIndexEnum.now)
        let next = this.getChildrenIndex(this.childrenIndexEnum.next)
        return [pre, now, next]
      },
      moveHide (direction) {
        let haveDraw = this.getShowIndex()
        let count = 2
        for (let i = 0; i < this.children.length; i++) {
          if (!haveDraw.includes(i)) {
            this.hideSomeone(i)
            this.transform(this.children[i], -1 * direction * count * (this.children[0].offsetWidth - 15))
            count++
          }
        }
      },
      moveProcess ({offset = 0} = {}) {
        let [pre, now, next] = this.getShowIndex()
        this.transform(this.children[now], -1 * offset)
        this.transform(this.children[pre], -1 * (this.children[0].offsetWidth - 15 + offset))
        this.transform(this.children[next], 1 * (this.children[0].offsetWidth - 15 - offset))
        this.scale()
      },
      hideSomeone (index) {
        this.children[index].style.visibility = 'hidden'
        setTimeout(() => {
          this.children[index].style.visibility = 'visible'
        }, 380)
      },
      getChildrenIndex (forward = 'now') {
        let forwardData = {
          'now': 0,
          'next': 1,
          'pre': -1
        }
        return (this.active + forwardData[forward] + this.children.length) % this.children.length
      },
      transform (el, offset) {
        el.style.webkitTransform = `translate3d(${offset}px, 0, 0)`
      },
      scale () {
        for (let i = 0; i < this.children.length; i++) {
          this.children[i].style.webkitTransform += i === this.active ? `scale3d(1,1,1)` : `scale3d(${this.scalePercent},${this.scalePercent},1)`
        }
      },
      stdBtn (fn) {
        fn.call(this)
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?57f5f384